// CreatorDashboard.js with enhancements
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./CreatorDashboard.css";


const CreatorDashboard = () => {
  const [creator, setCreator] = useState(null);
  const [title, setTitle] = useState("");
  const [videoFile, setVideoFile] = useState(null);
  const [thumbnailFile, setThumbnailFile] = useState(null);
  const [myVideos, setMyVideos] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [visibility, setVisibility] = useState("free");


  const navigate = useNavigate();

  useEffect(() => {
    const storedCreator = localStorage.getItem("creatorUser");
    if (storedCreator) {
      const parsedCreator = JSON.parse(storedCreator);
      setCreator(parsedCreator);
      fetchVideos(parsedCreator._id);
    }
  }, []);

  const fetchVideos = async (creatorId) => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/videos/creator/${creatorId}`);
      setMyVideos(res.data);
    } catch (err) {
      console.error("Failed to load videos", err);
    }
  };

  const handleUpload = async (e) => {
    e.preventDefault();

    if (!creator) {
      alert("Please log in as a creator.");
      return;
    }

    const formData = new FormData();
    formData.append("title", title);
    formData.append("creator", creator._id);
    formData.append("video", videoFile);
    formData.append("thumbnail", thumbnailFile);
    formData.append("visibility", visibility);


    try {
      setUploading(true);
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/videos/upload`, formData, {
        onUploadProgress: (progressEvent) => {
          const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setUploadProgress(percent);
        },
      });

      alert("Video uploaded successfully!");
      setTitle("");
      setVideoFile(null);
      setThumbnailFile(null);
      setUploadProgress(0);
      fetchVideos(creator._id);
    } catch (err) {
      console.error("Upload failed:", err);
      alert("Upload failed. Please try again.");
    } finally {
      setUploading(false);
    }
  };

  const handleDelete = async (videoId) => {
    if (!window.confirm("Are you sure you want to delete this video?")) return;
    try {
      await axios.delete(`${process.env.REACT_APP_API_URL}/api/videos/${videoId}`);
      fetchVideos(creator._id);
    } catch (err) {
      console.error("Delete failed:", err);
      alert("Delete failed.");
    }
  };

  const filteredVideos = myVideos.filter(video =>
    video.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
  <div className="creator-dashboard">
    {/* Top Navigation */}
    <nav className="top-nav">
      <div className="logo" onClick={() => navigate("/")}> NitinShukla</div>
      <div className="nav-links">
        <button onClick={() => navigate("/creator")}>Dashboard</button>
        <button onClick={() => navigate("/profile")}>Profile</button>
        {creator && (
          <button className="logout-btn" onClick={() => {
            localStorage.removeItem("creatorUser");
            navigate("/");
            window.location.reload();
          }}>
            Logout
          </button>
        )}
      </div>
    </nav>

    {/* Dashboard Header */}
    <header className="dashboard-header">
      <h2>Welcome Creator: {creator?.name}</h2>
      <p>Email: {creator?.email}</p>
    </header>

    {/* Upload Section */}
    <section className="upload-section">
      <h3>Upload New Video</h3>
      <form onSubmit={handleUpload} className="upload-form">
        <input type="text" placeholder="Video Title" value={title} onChange={(e) => setTitle(e.target.value)} required />
        <input type="file" accept="video/mp4" onChange={(e) => setVideoFile(e.target.files[0])} required />
        <input type="file" accept="image/*" onChange={(e) => setThumbnailFile(e.target.files[0])} required />
        <select value={visibility} onChange={(e) => setVisibility(e.target.value)} required>
  <option value="free">Free</option>
  <option value="paid">Paid</option>
</select>

        <button type="submit" disabled={uploading}>
          {uploading ? `Uploading... ${uploadProgress}%` : "Upload"}
        </button>
      </form>
      {uploading && <progress value={uploadProgress} max="100"></progress>}
    </section>

    {/* My Videos Section */}
    <section className="my-videos">
      <h3>My Uploaded Videos</h3>
      <input
        type="text"
        placeholder="Search by title..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      <div className="video-grid">
        {filteredVideos.length === 0 ? (
          <p>No videos found.</p>
        ) : (
          filteredVideos.map((video) => (
            <div key={video._id} className="video-card">
              <img src={`${process.env.REACT_APP_API_URL}${video.thumbnail}`} alt={video.title} width="200" />
              <h4>{video.title}</h4>
              <video width="300" controls>
                <source src={`${process.env.REACT_APP_API_URL}${video.videoUrl}`} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
              
              <button onClick={() => handleDelete(video._id)}>Delete</button>
            </div>
          ))
        )}
      </div>
    </section>
    <section class="footer-home">
        <h6>© 2025 Nitin Shukla. All rights reserved.</h6>
       
      </section>
  </div>
);
};

export default CreatorDashboard;
